import {
  RecentItemsGetters,
  RecentItemsActions,
  RecentItemsMutations
} from '@/app/features/recent-items/recent-items.keys';
import { recentItemsService } from '@/app/features/recent-items/recent-items.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

const RECENT_ITEMS_MENU_LIMIT = 10;

export const getInitialState = () => {
  return {
    recentItemsList: [],
    recentItemsForMenu: [],
    recentItemsFilteredRecordCount: 0,
    recentItemsSortOrder: {
      sortBy: 'initiatedAt',
      sortDirection: 'desc'
    },
    recentItemsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};

export const recentItemsStore = {
  state: getInitialState(),
  getters: {
    [RecentItemsGetters.RecentItemsForMenu]: state => {
      return state.recentItemsForMenu;
    },
    [RecentItemsGetters.RecentItemsList]: state => {
      return state.recentItemsList;
    },
    [RecentItemsGetters.SortBy]: state => {
      return state.recentItemsSortOrder.sortBy;
    },
    [RecentItemsGetters.SortDirection]: state => {
      return state.recentItemsSortOrder.sortDirection;
    },
    [RecentItemsGetters.RecentItemsListingOffset]: state => {
      return state.recentItemsPaginationParameters.offset;
    },
    [RecentItemsGetters.RecentItemsPerPage]: state => {
      return state.recentItemsPaginationParameters.recordsPerPage;
    },
    [RecentItemsGetters.RecentItemsFilteredRecordCount]: state => {
      return state.recentItemsFilteredRecordCount;
    }
  },
  actions: {
    [RecentItemsActions.RetrieveRecentItemsForMenu]: ({ commit }, userId) => {
      return recentItemsService
        .retrieveRecentItems(userId, RECENT_ITEMS_MENU_LIMIT)
        .then(items => {
          commit(RecentItemsMutations.SetRecentItemsForMenu, items);
        })
        .catch(err => {
          throw err;
        });
    },
    [RecentItemsActions.RetrieveRecentItemsList]: ({ state, commit, dispatch }, userId) => {
      return recentItemsService
        .retrieveRecentItems(
          userId,
          state.recentItemsPaginationParameters.recordsPerPage,
          state.recentItemsPaginationParameters.offset,
          state.recentItemsSortOrder
        )
        .then(items => {
          dispatch(RecentItemsActions.RetrieveRecentItemsFilteredRecordCount, userId);
          commit(RecentItemsMutations.SetRecentItemsList, items);
        })
        .catch(err => {
          throw err;
        });
    },
    [RecentItemsActions.RetrieveRecentItemsFilteredRecordCount]: ({ commit, dispatch }, userId) => {
      return recentItemsService
        .retrieveFilteredRecordCount(userId)
        .then(recordCount => {
          commit(RecentItemsMutations.SetRecentItemsFilteredRecordCount, recordCount);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('recentItems.listing.errors.retrieveRecentItems')
          });
        });
    },
    [RecentItemsActions.FilterRecentItems]: ({ commit, dispatch }, params) => {
      if (!params.isSearchKey) {
        dispatch(RecentItemsActions.RetrieveRecentItemsList, params.userId);
      } else {
        commit(RecentItemsMutations.SetRecentItemsList, params.filteredItems);
        commit(RecentItemsMutations.SetRecentItemsFilteredRecordCount, params.filteredItems.length);
      }
    },
    [RecentItemsActions.SetRecentItemsPaginationParameters]: ({ commit, dispatch }, params) => {
      commit(RecentItemsMutations.SetRecentItemsPaginationParameters, params.pagination);
      dispatch(RecentItemsActions.RetrieveRecentItemsList, params.userId);
    },
    [RecentItemsActions.SetRecentItemsSortOrder]: ({ commit, dispatch }, params) => {
      commit(RecentItemsMutations.SetRecentItemsSortOrder, params.sortOrder);
      commit(RecentItemsMutations.ResetRecentItemsPaginationOffset);
      dispatch(RecentItemsActions.RetrieveRecentItemsList, params.userId);
    },
    [RecentItemsActions.DeleteRecentItems]: ({ dispatch }, params) => {
      return recentItemsService
        .deleteRecentItems(params)
        .then(() => {
          dispatch(RecentItemsActions.RetrieveRecentItemsList, params.userId);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('recentItems.listing.errors.deleteRecentItems')
          });
        });
    }
  },
  mutations: {
    [RecentItemsMutations.SetRecentItemsForMenu]: (state, items) => {
      state.recentItemsForMenu = items;
    },
    [RecentItemsMutations.SetRecentItemsList]: (state, items) => {
      state.recentItemsList = items;
    },
    [RecentItemsMutations.SetRecentItemsFilteredRecordCount]: (state, recordCount) => {
      state.recentItemsFilteredRecordCount = recordCount;
    },
    [RecentItemsMutations.SetRecentItemsSortOrder]: (state, sortOrder) => {
      state.recentItemsSortOrder = sortOrder;
    },
    [RecentItemsMutations.SetRecentItemsPaginationParameters]: (state, pagination) => {
      state.recentItemsPaginationParameters = pagination;
    },
    [RecentItemsMutations.ResetRecentItemsPaginationOffset]: state => {
      state.recentItemsPaginationParameters.offset = 0;
    }
  }
};
